<template>
  <TabelaOSD
    :colunas="resolvedColumns"
    :linhas="table.rows"
    :carregando="table.isLoading"
    :total-linhas="table.totalRows"
    :pagina="pagination.page"
    :campo-ordenacao="pagination.sort"
    :ordem-ordenacao="pagination.order"
    :texto-tabela-vazia="$t('indicadoresNaoEncontrados')"
    @page-change="onPageChange"
    @sort-change="onSortChange"
    @reload="getAdmin"
  >
    <template #toolbar-actions>
      <ReceitasExport v-bind="pagination" :headers="headers" />
    </template>
    <template #toolbar-filters>
      <ReceitasFilters :loading="table.isLoading" @filter="onFilter" />
    </template>
  </TabelaOSD>
</template>

<script>
import ReceitasExport from './ReceitasExport.vue';
import ReceitasFilters from './ReceitasFilters.vue';
import TabelaOSD from '@/modules/shared/components/tabelaOSD/TabelaOSD.vue';
import { getPaginatedReceitasData } from '../receitasService';
import { useToast } from 'vue-toastification';
import { toDate } from '@/modules/core/utils/formats';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';

export default {
  components: { ReceitasExport, ReceitasFilters, TabelaOSD },
  data: () => ({
    table: {
      totalRows: 0,
      rows: [],
      columns: ref([
        {
          label: computed((_) => i18n.global.t('empresa')),
          field: 'empresa',
        }, {
          label: computed((_) => i18n.global.t('plataforma')),
          field: 'plataforma',
        }, {
          label: computed((_) => i18n.global.t('tipoDaAssinatura')),
          field: 'tipoAssinatura',
        }, {
          label: computed((_) => i18n.global.t('orderId')),
          field: 'orderId',
        }, {
          label: computed((_) => i18n.global.t('dataHoraExpiracao')),
          field: 'expiraEm',
          tdClass: 'text-break',
          formatFn: toDate,
        }, {
          label: computed((_) => i18n.global.t('status')),
          field: 'status',
          sortable: true,
        },

      ]),
      mode: 'remote',
      class: 'osd-table',
      styleClass: 'vgt-table bordered condensed',
      compactMode: true,
      lineNumbers: true,
      paginationOptions: {
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        nextLabel: '>',
        prevLabel: '<',
        infoFn: (params) => `
      ${params.firstRecordOnPage} - ${params.lastRecordOnPage} de ${params.totalRecords}
    `,
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'dataHoraCompra', type: 'desc' },
      },
      isLoading: false,
    },
    pagination: {
      page: 1,
      sort: 'dataHoraCompra',
      order: 'desc',
      search: '',
    },
  }),
  computed: {
    resolvedColumns() {
      return this.table.columns.map((column) => ({
        ...column,
        label: column.label?.value ?? column.label,
      }));
    },
    headers() { return this.resolvedColumns.map((column) => column.label); },
  },
  methods: {
    updateParams(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
    },
    onPageChange(page) {
      this.updateParams({ page });
      this.getAdmin();
    },
    onSortChange(field) {
      const nextOrder = this.pagination.sort === field && this.pagination.order === 'asc' ? 'desc' : 'asc';
      this.updateParams({
        page: 1,
        sort: field,
        order: nextOrder,
      });
      this.getAdmin();
    },
    onFilter(filters) {
      this.updateParams({ ...filters, page: 1 });
      this.getAdmin();
    },
    async getAdmin() {
      this.table.isLoading = true;
      try {
        const data = await getPaginatedReceitasData(this.pagination);
        this.table.rows = data.dados;
        this.table.totalRows = data.total;
      } catch (error) {
        useToast().error(ref(computed((_) => i18n.global.t('erroAoObterAsInfos'))));
      }
      this.table.isLoading = false;
    },
  },
};

</script>
